export default __webpack_public_path__ + "static/media/ReservationReport.5d9b52b8.png";